var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-btn',{on:{"click":function($event){$event.stopPropagation();return _vm.$emit('close')}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-card-text',{staticClass:"tree-view-container"},[_vm._t("body")],2),_vm._v(" "),_c('v-divider')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9d0b5d2","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/TreeViewModal.vue
// module id = null
// module chunks = 